export function stripHtml(value = '') {
  return String(value)
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\s+/g, ' ')
    .trim()
}

export function truncateText(value = '', max = 500) {
  const text = stripHtml(value)
  if (text.length <= max) {
    return text
  }
  return `${text.slice(0, max).trim()}…`
}

export function toAbsoluteUrl(pathOrUrl = '/', origin = 'https://elemental.ae') {
  if (!pathOrUrl) {
    return origin
  }

  if (/^https?:\/\//i.test(pathOrUrl)) {
    return pathOrUrl
  }

  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`
  return `${origin.replace(/\/$/, '')}${path}`
}

export function normalizeTime(value = '') {
  const match = String(value).trim().match(/^(\d{1,2}):(\d{2})/)
  if (!match) {
    return value
  }
  return `${match[1].padStart(2, '0')}:${match[2]}`
}

export function pickImageUrl(image) {
  if (!image) {
    return null
  }

  if (typeof image === 'string') {
    return image
  }

  return (
    image?.desktop?.x1 ||
    image?.desktop?.x2 ||
    image?.tablet?.x1 ||
    image?.mobile?.x1 ||
    image?.x1 ||
    image?.url ||
    null
  )
}

export function getBlockContent(block) {
  return block?.data?.content || ''
}

export function compact(value) {
  if (Array.isArray(value)) {
    const next = value.map(compact).filter((item) => item !== undefined && item !== null && item !== '')
    return next.length ? next : undefined
  }

  if (value && typeof value === 'object') {
    const next = {}
    Object.keys(value).forEach((key) => {
      const compacted = compact(value[key])
      if (compacted !== undefined && compacted !== null && compacted !== '') {
        next[key] = compacted
      }
    })
    return Object.keys(next).length ? next : undefined
  }

  return value
}
